export const convertTicketTypeAsName = {
	PAY: '구매',
	RECEIVE_BY_PRIZE: '상품 수령',
	RECEIVE_DIRECT: '직접 수령',
	WITHDRAW_BY_MANAGER: '매니저에 의해 출금',
	WITHDRAW_BY_ADMIN: '관리자에 의해 출금',
}

export const convertClassificationAsName = {
	ISSUE: '본사 지급',
	RETURN: '반환',
	REVOKE: '본사 회수',
}
